import { render, staticRenderFns } from "./MrDetails.vue?vue&type=template&id=af3528f8&scoped=true&"
import script from "./MrDetails.vue?vue&type=script&lang=js&"
export * from "./MrDetails.vue?vue&type=script&lang=js&"
import style0 from "./MrDetails.vue?vue&type=style&index=0&id=af3528f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3528f8",
  null
  
)

export default component.exports